







import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import PageTitle from '@/components/common/PageTitle.vue';

@Component({
  components: { AdminIframe, PageTitle },
})
export default class ProductListIframe extends Vue {
  private remoteSrc = '';

  private setRemoteSrc() {
    const query = this.$route.query;
    const queryObject = { ...query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
    this.remoteSrc = process.env.VUE_APP_ADMIN_REMOTE_URL + '/product/management/list?' + queryString;
  }

  created() {
    this.setRemoteSrc();
  }
}
